import React from "react";
import "./HBottom.css";
import { HeroData } from "../../utils/data";
import { motion } from "framer-motion";
import { containerVariants } from "../../utils/animation";

const HBottom = () => {
  return (
    <div className="h-bottom-wrapper">
      <div className="h-b-wrapper">
        <div className="h-b-left">
          <div className="h-left-inner">
            <div className="image-row">
              {HeroData.slice(2, 6).map((person, i) => (
                <motion.div
                  variants={containerVariants(0.2 + i * 0.1)}
                  initial="offscreen"
                  whileInView={"onscreen"}
                  viewport={{ once: false, amount: 0.3 }}
                  className="person-pill-wrapper"
                  key={i}
                >
                  {/* Pill image — overflow hidden for the rounded shape */}
                  <div className="person-pill">
                    <div className="person-pill-bg">
                      <img src={person.src} alt={person.des || "Team member"} loading="lazy" />
                    </div>
                  </div>

                  {/* Label — OUTSIDE the overflow:hidden pill so it's never clipped */}
                  <div className="pill-label">
                    <span>{person.des}</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HBottom;
